import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "../../utils/axiosInstance";
import { getToken } from "../../utils/getToken";

type CreditManagementQueryParams = {
  status?: string;
  startDate?: string;
  endDate?: string;
  search?: string;
};

export const useGetCreditManagementQuery = (
  params: CreditManagementQueryParams
) => {
  const token = getToken();

  const filteredParams = Object.fromEntries(
    Object.entries(params).filter(([_, value]) => value !== "")
  );

  return useQuery({
    queryKey: ["useGetCreditManagementQuery", filteredParams],
    queryFn: () =>
      axiosInstance
        .get("credits", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: filteredParams,
        })
        .then((res) => res.data),
    enabled: !!token,
  });
};
